<ng-template #loaderBlock>
  <app-loader></app-loader>  
</ng-template>
<div class="stepProgressBar">
  <nav>
    <ul class="step-list">
      <li class="step-list__item" *ngFor="let history of histories">
        <div class="divisions">
          <div class="bullet"></div>
          <span>{{history.eventDate | date :'MMM d, y'}}</span>
          <p> {{history.description}}</p>
        </div>
      </li>
    </ul>
  </nav>
  <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
</div>
